try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Accordion } from '@design-system/accordion';
import { Button } from '@design-system/button';
import { ExtendableImage } from '@design-system/extendable-image';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';

const createQueryString = (obj) => {
    const str = [];
    Object.keys(obj).forEach((key) => {
        str.push(`${key}=${obj[key]}`);
    });
    return str.join('&');
};

const Video = forwardRef(({ className, link, queryParams = { modestbranding: 1, rel: 0, enablejsapi: 1 }, preview, transcript, iframeTitle, noJsLabel, }, ref) => {
    const [isActive, setIsActive] = useState(false);
    const playVideo = () => setIsActive(true);
    return (jsxs("div", Object.assign({ ref: ref, className: classNames('cds-video', className) }, { children: [jsxs("div", Object.assign({ className: "cds-video__wrapper" }, { children: [isActive || !preview ? (jsx("iframe", { className: "cds-video__frame", "data-testid": "video-iframe", loading: "lazy", src: `${link}?${createQueryString(queryParams)}${preview ? '&autoplay=1' : ''}`, title: iframeTitle, allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true })) : (jsxs(Fragment, { children: [jsx("div", Object.assign({ className: "cds-video__preview" }, { children: jsx(ExtendableImage, Object.assign({ className: "cds-video__preview-image", "data-testid": "preview-image" }, preview.previewImage)) })), jsx("div", Object.assign({ className: "cds-video__btn_wrapper" }, { children: jsx(Button, Object.assign({ className: "cds-video__preview-btn", "data-testid": "preview-button", variant: "primary-icon", size: "large", onClick: playVideo }, preview.previewBtn)) }))] })), jsx("noscript", { children: noJsLabel && (jsx("div", Object.assign({ className: "cds-video__no-js" }, { children: jsx(Typography, { className: "cds-video__no-js-text", "data-testid": "no-js-text", tag: "p", variant: "body", size: "s", content: noJsLabel }) }))) })] })), (isActive || !preview) && transcript && (jsx(Accordion, { headlineTag: "h2", className: "cds-video__transcript", semanticVariant: "div", "data-testid": "transcript", items: [
                    {
                        title: transcript.transcriptLabel,
                        children: (jsx(Typography, { tag: "div", variant: "body", size: "m", content: transcript.transcriptContent })),
                    },
                ] }))] })));
});

export { Video };
